import Report, { ReportFormProps } from 'common/pages/report/Container.tsx'

export const ReportFormAgency = (props: ReportFormProps) => <Report {...props} />
